import { Amplify } from 'aws-amplify';
import { amplifyConfig } from './config';

// Configure Amplify with error handling
try {
  // Only configure if we have valid credentials
  if (amplifyConfig.Auth?.Cognito?.userPoolId && amplifyConfig.Auth?.Cognito?.userPoolClientId) {
    // Log the configuration being applied (for debugging)
    const cognitoConfig: any = amplifyConfig.Auth.Cognito;
    const oauthConfig = cognitoConfig?.loginWith?.oauth;
    console.log('Configuring AWS Amplify with:', {
      userPoolId: amplifyConfig.Auth.Cognito.userPoolId,
      userPoolClientId: amplifyConfig.Auth.Cognito.userPoolClientId,
      hasOAuthConfig: !!oauthConfig,
      oauthDomain: oauthConfig?.domain,
      oauthLocation: 'Auth.Cognito.loginWith.oauth',
    });
    
    Amplify.configure(amplifyConfig);
    
    // Verify OAuth config was applied (check under Cognito.loginWith.oauth)
    const currentConfig: any = Amplify.getConfig();
    const currentOAuthConfig = currentConfig.Auth?.Cognito?.loginWith?.oauth;
    if (oauthConfig) {
      if (currentOAuthConfig) {
        console.log('AWS Amplify configured successfully with OAuth');
        console.log('OAuth config location: Auth.Cognito.loginWith.oauth');
        console.log('OAuth config:', currentOAuthConfig);
      } else {
        console.warn('AWS Amplify configured but OAuth config not found in getConfig()');
        console.warn('Expected location: Auth.Cognito.loginWith.oauth');
        console.warn('Current Auth.Cognito:', currentConfig.Auth?.Cognito);
        console.warn('This might indicate a configuration issue');
      }
    } else {
      console.log('AWS Amplify configured successfully (no OAuth)');
    }
  } else {
    console.warn('AWS Amplify configuration skipped - missing credentials');
  }
} catch (error) {
  console.error('Failed to configure AWS Amplify:', error);
}

export default Amplify;
